<template>
  <div>
    <h1>As seen in</h1>
    <div id="creators-grid">
      <div class="videowrapper">
        <iframe
          class="youtube-vid"
          :src="videoUrl"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreatorGallery",
  data() {
    return {
      videoUrl: "https://www.youtube.com/embed/0CTp1a-aCUM?start=860",
    };
  },
};
</script>

<style scoped>
.videowrapper {
  float: none;
  clear: both;
  width: 100%;
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 25px;
  height: 0;
  border-radius: 12px;
  overflow: hidden;
}
.videowrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 12px;
}
</style>
